import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIRouterModule } from '@uirouter/angular';
import { HomeComponent } from './home.component';
import { SharedModule } from '../../shared/shared.module';
import { STATE_HOME } from '../../shared/app-states';
import { GaStateDeclaration } from '../../../type_definitions/datatypes';

const states:GaStateDeclaration[] = [
  {
    name: STATE_HOME,
    url: '/home',
    views: {
      content: {
        component: HomeComponent
      }
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    UIRouterModule.forChild({ states })
  ],
  declarations: [HomeComponent]
})
export class HomeModule { }